module.exports = __webpack_public_path__ + "static/img/green products card_02.2e1dac80.jpg";